import React from "react";
import { SentryReporterContext, SentryReporterInterface } from "../..";

type Props = {
  children: React.ReactNode;
  reporter: SentryReporterInterface;
};

export const SentryReporterProvider = (props: Props) => {
  return (
    <SentryReporterContext.Provider value={props.reporter}>
      {props.children}
    </SentryReporterContext.Provider>
  );
};
